import { DatePicker } from "antd";
import { useFormContext } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { FormType } from "../../types/form-type.ts";

export function ObjectFormDeadline() {
  const { control, watch } = useFormContext<FormType>();

  const buildingStart = watch("buildingStart");

  return (
    <div className="form-section">
      <h3>Сроки строительства</h3>
      <div className="field-group">
        <FormItem name="buildingStart" control={control} style={{ margin: 0 }}>
          <DatePicker placeholder="Начало" format="DD.MM.YYYY" />
        </FormItem>
        <FormItem control={control} name="buildingEnd" style={{ margin: 0 }}>
          <DatePicker
            disabledDate={(date) => {
              if (!date) return false;
              return buildingStart ? date.isBefore(buildingStart) : false;
            }}
            placeholder="Окончание"
            format="DD.MM.YYYY"
          />
        </FormItem>
      </div>
    </div>
  );
}
